// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'compass-solid';

export const Component = () => (
  <>
    <path d='M20.93 3.592C18.535 1.198 15.662 0 12.26 0c-3.4 0-6.273 1.198-8.668 3.592C1.198 5.987 0 8.86 0 12.261c0 3.4 1.198 6.274 3.592 8.669 2.395 2.394 5.268 3.592 8.669 3.592 3.4 0 6.274-1.198 8.669-3.592 2.394-2.395 3.592-5.268 3.592-8.67 0-3.4-1.198-6.273-3.592-8.668ZM2.923 12.26c0 .335-.144.48-.48.48-.334 0-.478-.145-.478-.48 0-.335.144-.479.479-.479.335 0 .479.144.479.48Zm8.859-9.818c0-.335.144-.479.479-.479.335 0 .479.144.479.48 0 .334-.144.478-.48.478-.334 0-.478-.144-.478-.479Zm.959 19.637c0 .335-.144.479-.48.479-.334 0-.478-.144-.478-.48 0-.334.144-.478.479-.478.335 0 .479.144.479.479Zm6.8-17.098-3.448 11.111-11.111 3.449L8.43 8.43l11.111-3.45Zm3.018 7.28c0 .334-.144.478-.48.478-.334 0-.478-.144-.478-.479 0-.335.144-.479.479-.479.335 0 .479.144.479.48Z' />
    <path d='M10.537 13.984a2.352 2.352 0 0 0 1.725.72c.67 0 1.245-.24 1.724-.72a2.352 2.352 0 0 0 .719-1.724c0-.67-.24-1.245-.72-1.724a2.352 2.352 0 0 0-1.723-.719c-.67 0-1.246.24-1.725.719a2.352 2.352 0 0 0-.718 1.724c0 .67.239 1.245.718 1.724Z' />
  </>
);

export const viewBox = '0 0 25 25';
